import { render, staticRenderFns } from "./RegistrationMapitConnect.vue?vue&type=template&id=1e54deb2&scoped=true"
import script from "./RegistrationMapitConnect.vue?vue&type=script&lang=ts"
export * from "./RegistrationMapitConnect.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationMapitConnect.vue?vue&type=style&index=0&id=1e54deb2&prod&lang=css"
import style1 from "./RegistrationMapitConnect.vue?vue&type=style&index=1&id=1e54deb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54deb2",
  null
  
)

export default component.exports